const RoleNames = Object.freeze({
  Admin: 'Admin',
  Staff: 'Staff',
  Customer: 'Customer',
  Reports: 'Reports',
  ReportsAdvanced: 'ReportsAdvanced',
  AppManager: 'AppManager',
  CampaignManager: 'CampaignManager',
  User: 'User',
  Tps: 'Tps',
  Waiter: 'Waiter',
  Kiosk: 'Kiosk',
  TimeTracking: 'Timetracking',
  Wiesn: 'Wiesn',
  TpsLocationAdmin: 'TpsLocationAdmin',
});

export default RoleNames;
